import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { changeChartType } from "../redux/customChartSagas";
import { Chart } from "react-google-charts";
import { CFormText } from "@coreui/react";
import areaChartImage from "./../../../assets/images/area_chart_example.png";
import columnChartImage from "./../../../assets/images/column_chart_example.png";
import barChartImage from "./../../../assets/images/bar_chart_example.png";
import comboChartImage from "./../../../assets/images/combo_chart_example.png";
import CategoryDropdown from "./CategoryDropdown";

const chartImages = [
  { src: barChartImage, type: "BarChart" },
  { src: columnChartImage, type: "ColumnChart" },
  { src: comboChartImage, type: "ComboChart" },
  { src: areaChartImage, type: "AreaChart" }
];

const PreviewContent = ({ name, onInputChange }) => {
  const dispatch = useDispatch();
  const {
    graph_type,
    selectedCategories: { category },
    chart: {
      data_table: { rows = [], cols = [] },
      options
    }
  } = useSelector((state) => state.customCharts.previewModalData);

  return (
    <div className="preview light" id="preview">
      <div className="preview--left">
        <div className="chart-selector">
          {chartImages.map(({ src, type }) => (
            <img
              draggable={false}
              key={type}
              src={src}
              alt={type}
              className={`chart-selector__image ${
                graph_type === type ? "chart-selector__image--active" : ""
              }`}
              onClick={() => dispatch(changeChartType(type))}
            />
          ))}
        </div>
      </div>
      <div className="preview--right">
        <div className="preview__section preview__section--input">
          <div className="section__el">
            <input
              maxLength={100}
              onChange={(e) => {
                onInputChange(e.target.value);
              }}
              className="text-input"
              type="text"
              placeholder="Enter chart title here..."
              value={name}
            />

            <CFormText className="help-block">
              {name && name.trim() ? "" : "* Please add name"}
            </CFormText>
          </div>
        </div>

        <div className="preview__section   preview__section--dropdowns">
          <div className="preview__section__el">
            <CategoryDropdown
              categoryKey="category"
              name="Primary Metric"
              targetKey="category_target"
            />
            <CFormText className="help-block">{category ? "" : "* Please add name"}</CFormText>
          </div>
          <div className="preview__section__el comparable">
            {category && (
              <CategoryDropdown
                categoryKey="compare_category"
                name="Comparable Metric"
                targetKey="compare_category_target"
              />
            )}
          </div>
        </div>
        <div className="preview__section preview__section--chart">
          {cols.length && rows.length ? (
            <Chart
              chartType={graph_type}
              rows={rows}
              columns={cols}
              key={graph_type}
              options={options}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PreviewContent;
